import { render } from "./BoardModal.vue?vue&type=template&id=14e87996"
import script from "./BoardModal.vue?vue&type=script&lang=js"
export * from "./BoardModal.vue?vue&type=script&lang=js"
script.render = render

export default script